import { formatAmounts, pluralize } from '@aytm/app/stats/lib/util/helpers'
import { processText } from '@aytm/app/stats/page/components/lib/utils'

const isBaVersion = answer => answer?.mds?.version !== undefined && 3 <= answer.mds.version

// the smoothed-scores matrix holds one column per attribute, in attribute order from zero
const scoreForBatch = (scoreList, qvIndex, b) => scoreList?.[qvIndex]?.[b.position - 1]

const buildAssociatedList = ({ dist, batches, scoreList, qvIndex, answer, qvId }) =>
  dist.brands[qvId]
    .reduce((acc, cur) => {
      if (cur[1] > 0.33 * dist.max) return acc

      const b = batches[Number(cur[0].slice(1)) - 1]
      const text = `<b>${processText(b.text)}</b>`

      if (scoreList) {
        const score = scoreForBatch(scoreList, qvIndex, b)
        if (score !== undefined && score !== null) {
          acc.push(`${text} (${isBaVersion(answer) ? 'BA score' : 'score'}: ${score.toFixed(1)})`)
        } else {
          acc.push(text)
        }
      } else if (answer.meanList) {
        const score = answer.meanList?.[qvId]?.[cur[0]]
        if (score !== undefined && score !== null) {
          acc.push(`${text} (${isBaVersion(answer) ? 'BA score' : 'score'}: ${score.toFixed(1)})`)
        } else {
          acc.push(text)
        }
      } else {
        acc.push(text)
      }

      return acc
    }, [])
    .join(', ')

export const calcMdsItemsListProps = ({ id, answer, questionVariants, batches, mdsBrandsValue, chartLegendMode }) => {
  const isLoading = 'loading' === answer

  const responses = answer?.total || 0
  const scoreList = answer?.mds?.scoresSmoothed || null

  const cols = [
    { type: 'title', title: 'Entities' },
    {
      type: 'value',
      title: 'Most associated attributes',
      width: 500,
      appendix: `${formatAmounts(responses)} ${pluralize(responses, 'response', 'responses')}`
    }
  ]

  const rows = questionVariants.map((qv, i) => {
    const qvId = `qv${qv.position}`

    const row = {
      cells: [
        {
          title: `${qv.position}. ${processText(qv.text)}${'long' !== chartLegendMode ? ` (E${qv.position})` : ''}`,
          colorIndex: ((qv.position - 1) % 21) + 1
        },
        { value: '', loading: isLoading, classNames: ['left'] }
      ],
      disabled: 0 < mdsBrandsValue.length && !mdsBrandsValue.includes(String(qv.position)),
      position: qv.position
    }

    if (answer?.mds?.dist?.brands[qvId] !== undefined) {
      row.cells[1].value = buildAssociatedList({ dist: answer.mds.dist, batches, scoreList, qvIndex: i, answer, qvId })
    }

    if (Object.hasOwn(qv, 'image')) {
      row.cells[0].image = qv.image
    }

    return row
  })

  return { id, cols, rows, classNames: ['plain'] }
}
